import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportDeviceMounts(companyId) {
	return dataTransferWrap(
		ModulesMap.REPORT_DEVICE_MOUNTS,dtConfig[ModulesMap.REPORT_DEVICE_MOUNTS].getReportDeviceMounts,
		{
			urlParams: {
				companyId,
			},
		},
	)
}
function getReportDeviceMount(companyId, deviceMountId) {
	return dataTransferWrap(
		ModulesMap.REPORT_DEVICE_MOUNTS,dtConfig[ModulesMap.REPORT_DEVICE_MOUNTS].getReportDeviceMount,
		{
			urlParams: {
				companyId,
				deviceMountId,
			},
		},
	)
}

export default {
	getReportDeviceMounts,
	getReportDeviceMount,
}
